import Image, { type StaticImageData } from 'next/image';
import { cn } from '@/helpers/utils';

import en from '../public/img/flags/en.svg';
import cs from '../public/img/flags/cs.svg';
import es from '../public/img/flags/es.svg';
import ro from '../public/img/flags/ro.svg';
import pl from '../public/img/flags/pl.svg';

const svg: Record<string, StaticImageData> = {
    cs,
    en,
    es,
    ro,
    pl,
};

type FlagProps = {
    country: string;
    className?: string;
};

export default function Flag({ country, className = '' }: FlagProps) {
    if (!svg[country]) return null;

    return (
        <div className={cn('w-[25px] h-[25px] relative rounded-full', className)}>
            <Image
                src={svg[country]}
                sizes="25px"
                className="size-full rounded-full object-cover object-center"
                alt={country.toUpperCase()}
            />
        </div>
    );
}
